import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'
import WhoCanContactMeContainer from './WhoCanContactMeContainer'
import MatchFiltersContainer from './MatchFiltersContainer'

class FilterContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tab: 0,
    }

    this.applyFilters = this.applyFilters.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  applyFilters() {
    this.props.getMatches()
  }

  closeModal() {
    this.props.toggleFilterSection()
  }

  introCopy() {
    if (this.state.tab === 0) {
      return 'Set your preferences, then show matches.'
    }
    return 'Control who can reach out to you.'
  }

  renderTabs() {
    const tabs = [
      { id: 0, label: 'Find matches' },
      { id: 1, label: 'Privacy', ariaLabel: 'Who can contact me' },
    ]

    return (
      <div className="matchFiltersModal__tabs" role="tablist" aria-label="Filter sections">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={this.state.tab === tab.id}
            aria-label={tab.ariaLabel || tab.label}
            className={[
              'matchFiltersModal__tab',
              this.state.tab === tab.id ? 'matchFiltersModal__tab--active' : '',
            ].filter(Boolean).join(' ')}
            onClick={() => this.setState({ tab: tab.id })}
          >
            {tab.label}
          </button>
        ))}
      </div>
    )
  }

  render() {
    const { tab } = this.state

    return (
      <StandardModal
        onClose={this.closeModal}
        title="Match filters"
        modalClass="matchFiltersModal"
        overlayClass="matchFiltersModalOverlay"
      >
        <div className="matchFiltersModal__shell">
          <header className="matchFiltersModal__header">
            <h2 className="matchFiltersModal__title">Filters</h2>
            {this.renderTabs()}
            <p className="matchFiltersModal__intro">{this.introCopy()}</p>
          </header>

          <div className="matchFiltersModal__scroll">
            {tab === 0 && (
              <MatchFiltersContainer
                current_user={this.props.current_user}
                languages_users={this.props.languages_users}
                premiumUser={this.props.premiumUser}
                toggleProModal={this.props.toggleProModal}
                filters={this.props.filters}
                updateFilter={this.props.updateFilter}
                learningLanguages={this.props.learningLanguages}
                nativeLanguages={this.props.nativeLanguages}
              />
            )}
            {tab === 1 && (
              <WhoCanContactMeContainer
                current_user={this.props.current_user}
                idVerification={this.props.idVerification}
                premiumUser={this.props.premiumUser}
                pro_settings={this.props.pro_settings}
                toggleProModal={this.props.toggleProModal}
                updateIdVerification={this.props.updateIdVerification}
                updateUserSettings={this.props.updateUserSettings}
              />
            )}
          </div>

          <footer className="matchFiltersModal__footer">
            {tab === 0 ? (
              <StandardButton
                text="Show matches"
                size="large"
                primary={true}
                fullWidth={true}
                onClick={this.applyFilters}
              />
            ) : (
              <StandardButton
                text="Done"
                size="large"
                primary={true}
                fullWidth={true}
                onClick={this.closeModal}
              />
            )}
          </footer>
        </div>
      </StandardModal>
    )
  }
}

FilterContainer.propTypes = {
  current_user: PropTypes.object.isRequired,
  pro_settings: PropTypes.object,
  idVerification: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  languages_users: PropTypes.array,
  premiumUser: PropTypes.bool,
  toggleProModal: PropTypes.func.isRequired,
  toggleFilterSection: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
  getMatches: PropTypes.func.isRequired,
  learningLanguages: PropTypes.array,
  nativeLanguages: PropTypes.array,
  updateIdVerification: PropTypes.func.isRequired,
  updateUserSettings: PropTypes.func.isRequired,
}

export default FilterContainer
